import { render, staticRenderFns } from "./OnboardingTable.vue?vue&type=template&id=a830ca46&"
import script from "./OnboardingTable.vue?vue&type=script&lang=js&"
export * from "./OnboardingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports